<section class="turnstile" [class.show]="showTurnstile">
  <div class="turnstile__modal">
    <p class="turnstile__modal-title">Sprawdzanie czy połączenie z witryną jest bezpieczne</p>
    <ng-cloudflare-turnstile id="name" [config]="config"></ng-cloudflare-turnstile>
    <p class="turnstile__modal-desc">Strona https://info-car.pl/new/ musi przeanalizować bezpieczeństwo Twojego
      połączenia przed przejściem dalej.</p>
  </div>
</section>

<app-layout (keyup.TAB)="addFocusClass()" (keydown.SHIFT.TAB)="addFocusClass()" (click)="removeFocusClass()"
  (changeLng)="changeLng($event)" [ngClass]="focusOnTab ? 'focusElement' : ''"></app-layout>

<app-loaders fullScreen="true" type="splash" bdColor="#2434B3" animation="fadeOut" [show]="!routerLoaded"
  disableScroll="true"></app-loaders>